import { END_POINTS } from "../helpers";
import { CommonBody, OtpResponse, Users } from "../types/General";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  statusCode: number;
  data?: User;
  message: string;
};

type PostForgotPasswordResponse = {
  statusCode: number;
  data?: User;
  message: string;
};

type PostResetPasswordResponse = {
  statusCode: number;
  data?: any;
  message: string;
};

type PostChangePasswordResponse = {
  statusCode: number;
  data?: any;
  message: string;
};

type GetProfileResponse = {
  statusCode: number;
  code?: number;
  data?: any;
};

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

type GetUsersResponse = {
  approvedCount: number;
  count: number;
  pendingCount: number;
  rejectCount: number;
  user: Users[];
};

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postVerifyOtp: builder.mutation<
      CommonResponseType & { data: OtpResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.verifyOtp,
        method: "POST",
        body,
      }),
    }),
    postLogin: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.login,
        method: "POST",
        body,
      }),
    }),
    postForgotPassword: builder.mutation<
      PostForgotPasswordResponse,
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.forgotPassword,
        method: "POST",
        body,
      }),
    }),
    postSetProfile: builder.mutation<
      CommonResponseType & { data: any },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.updateProfile,
        method: "PUT",
        body,
      }),
    }),
    postResetPassword: builder.mutation<PostResetPasswordResponse, CommonBody>({
      query: (body) => ({
        url: END_POINTS.resetPassword,
        method: "POST",
        body,
      }),
    }),
    postChangePassword: builder.mutation<
      PostChangePasswordResponse,
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.changePassword,
        method: "POST",
        body,
      }),
    }),
    getProfile: builder.query<GetProfileResponse, {}>({
      query: () => ({
        url: END_POINTS.getProfile,
        method: "GET",
      }),
    }),

    logoutApi: builder.query<CommonResponse, {}>({
      query: () => ({
        url: END_POINTS.logout,
        method: "GET",
      }),
    }),

    getUsers: builder.query<
      CommonResponse & { data: GetUsersResponse },
      {
        page: number;
        limit: number;
        search: string;
        role: number;
        status?: number;
      }
    >({
      query: ({ page, limit, search, role, status }) => ({
        url: `${END_POINTS.users}?page=${page}&limit=${limit}&role=${role}${
          status ? `&status=${status}` : ""
        }${search?.length ? `&search=${search}` : ""}`,
        method: "GET",
      }),
    }),
    updateUserProfile: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.editUser}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteUser: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.users}/${id}`,
        method: "DELETE",
      }),
    }),
    getUserById: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getUsersById}/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  usePostLoginMutation,
  usePostVerifyOtpMutation,
  usePostSetProfileMutation,
  usePostForgotPasswordMutation,
  usePostResetPasswordMutation,
  usePostChangePasswordMutation,
  useLazyGetProfileQuery,
  useLazyLogoutApiQuery,
  useLazyGetUsersQuery,
  useUpdateUserProfileMutation,
  useLazyDeleteUserQuery,
  useLazyGetUserByIdQuery,
} = authApi;
